import { render, staticRenderFns } from "./VuetablePaginationBootstrap.vue?vue&type=template&id=f9306502&"
import script from "./VuetablePaginationBootstrap.vue?vue&type=script&lang=js&"
export * from "./VuetablePaginationBootstrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports